import { ProvisionWizardFormData } from "../types";

const AZURE_SQL_SERVER = /\.database\.windows\.net$/i;

// A blank elastic pool on Azure would create a standalone, higher-cost database, which
// PBIN now rejects; catch it here so the operator gets immediate feedback. Heuristic only
// (the wizard has just the server name) - PBIN is the authoritative guard for Azure servers
// this pattern can't detect. VM-hosted and local SQL Server have no pools, so blank is fine.
export function isAzureSqlServer(databaseServer: string): boolean {
  return AZURE_SQL_SERVER.test(databaseServer.trim());
}

export function validateProductConfig(data: ProvisionWizardFormData): boolean {
  return (
    data.config.databaseServer.trim().length > 0 &&
    data.config.databaseCatalog.trim().length > 0 &&
    // The shared Auth database is required: user assignment (Auth WCF
    // LogInWithOktaAccessToken / local UserID resolution) cannot work without it.
    // User/password stay optional - blank means integrated security (local dev).
    data.config.authDatabaseServer.trim().length > 0 &&
    data.config.authDatabaseCatalog.trim().length > 0 &&
    data.config.storageTypeId > 0 &&
    !(isAzureSqlServer(data.config.databaseServer) &&
      data.config.elasticPoolName.trim().length === 0)
  );
}

export function validateFirmProfile(data: ProvisionWizardFormData): boolean {
  return (
    data.firmProfile.companyName.trim().length > 0 &&
    data.firmProfile.dtcNo.trim().length > 0
  );
}

// Account types and DTCs are optional at provisioning (the app's historical day-zero
// is empty catalogs, built in-app) - so they don't gate completion.
export function validateAll(data: ProvisionWizardFormData): boolean {
  return validateProductConfig(data) && validateFirmProfile(data);
}
